<app-block-wrapper [_editable]="_editable" [style]="style">
  <a
    appButton
    name="custom-button"
    location="storyblok-button"
    [target]="link.target"
    [color]="buttonStyle"
    [spacing]="buttonSpacing"
    [height]="buttonSize"
    [center]="alignment === 'center'"
    [desktopAlignment]="desktopAlignment"
    [tabletAlignment]="tabletAlignment"
    [mobileAlignment]="mobileAlignment"
    [weight]="bold ? 'bold' : 'normal'"
    [shape]="corners"
    [size]="textSize"
    [hasIcon]="!!icon"
    [routerLink]="href"
    *ngIf="internalLink"
  >
    <app-svg src="assets/icons/{{ icon }}.svg" *ngIf="icon && iconPosition === 'left'"></app-svg>
    <span>{{ text }}</span>
    <app-svg src="assets/icons/{{ icon }}.svg" *ngIf="icon && iconPosition === 'right'"></app-svg>
  </a>
  <a
    appButton
    name="custom-button"
    location="storyblok-button"
    [color]="buttonStyle"
    [target]="link.target"
    [spacing]="buttonSpacing"
    [height]="buttonSize"
    [center]="alignment === 'center'"
    [desktopAlignment]="desktopAlignment"
    [tabletAlignment]="tabletAlignment"
    [mobileAlignment]="mobileAlignment"
    [weight]="bold ? 'bold' : 'normal'"
    [shape]="corners"
    [size]="textSize"
    [hasIcon]="!!icon"
    [href]="href"
    *ngIf="!internalLink"
  >
    <app-svg src="assets/icons/{{ icon }}.svg" *ngIf="icon && iconPosition === 'left'"></app-svg>
    <span>{{ text }}</span>
    <app-svg src="assets/icons/{{ icon }}.svg" *ngIf="icon && iconPosition === 'right'"></app-svg>
  </a>
</app-block-wrapper>
